<h2>{{ 'cart.savedCartList.savedCartHeader' | cxTranslate }}</h2>
<ng-container *ngIf="isLoadingSavedCartsData; else showSavedCartsListTable">
  <div class="loading-container">
    <mat-spinner [diameter]="72"></mat-spinner>
  </div>
</ng-container>
<ng-template #showSavedCartsListTable>
  <p
    *ngIf="savedCartsCount >= 0"
    [innerHtml]="'cart.savedCartList.savedCartsInfo' | cxTranslate : { count: savedCartsCount }"
  ></p>

  <div class="d-flex flex-sm-column flex-md-row justify-content-md-between" *ngIf="savedCartsCount > 0">
    <app-sorting
      [sortOptions]="sortOptions"
      [sortLabels]="sortLabels | async"
      (sortListEvent)="sortChange($event)"
      [selectedOption]="sort"
    >
    </app-sorting>
    <div class="import-csv-container">
      <button class="btn btn-link p-0 border-0" mat-icon-button disableRipple (click)="goToBulkImport()">
        <mat-icon svgIcon="import" class="import align-middle"></mat-icon
        ><span class="align-middle">{{ 'csvImport.label' | cxTranslate }}</span>
      </button>
    </div>
  </div>

  <app-table
    *ngIf="savedCartsCount > 0 && showSrp && isDesktop"
    [columns]="columnsSrpOn"
    [dataSource]="dataSource"
    [pageSize]="payload.pageSize"
    [paginator]="null"
  >
  </app-table>

  <app-table
    *ngIf="savedCartsCount > 0 && !showSrp && isDesktop"
    [columns]="columnsSrpOff"
    [dataSource]="dataSource"
    [pageSize]="payload.pageSize"
    [paginator]="null"
  >
  </app-table>

  <div class="saved-carts-list-container mobile">
    <div class="card-columns" *ngIf="!isDesktop && savedCartsData">
      <div class="card border-0" *ngFor="let cart of savedCartsData">
        <div class="card-body">
          <h5 class="card-title mb-0">{{ columnsSrpOn[0].displayName }}</h5>
          <a
            tabindex="0"
            class="card-text text-force-truncate"
            [routerLink]="{ cxRoute: 'savedcartDetails', params: cart } | cxUrl"
          >
            <app-tooltip-text [tooltipContent]="cart.name" [content]="cart.name" placement="bottom"></app-tooltip-text>
          </a>
          <div class="row no-gutters">
            <div class="col-6 cart-code">
              <h5 class="card-title mb-0">{{ columnsSrpOn[1].displayName }}</h5>
              <p class="card-text">{{ cart.code }}</p>
            </div>
            <div class="col-6">
              <h5 class="card-title mb-0">{{ columnsSrpOn[2].displayName }}</h5>
              <p class="card-text">{{ cart.saveTime | date : 'dd-MM-yyyy' }}</p>
            </div>
          </div>
          <div class="row no-gutters">
            <div class="col-6 created-by">
              <h5 class="card-title mb-0">{{ columnsSrpOn[3].displayName }}</h5>
              <p class="card-text">{{ cart.createdBy }}</p>
            </div>
            <div class="col-6" *ngIf="!showSrp">
              <h5 class="card-title mb-0">{{ columnsSrpOff[4].displayName }}</h5>
              <p class="card-text">{{ cart.dealerPrice }}</p>
            </div>
          </div>
          <div class="row no-gutters">
            <div class="col-6">
              <h5 class="card-title mb-0">{{ columnsSrpOn[4].displayName }}</h5>
              <p class="card-text">{{ cart.importStatus == 'PROCESSING' ? '-' : cart.totalItems }}</p>
            </div>
          </div>
          <div class="row no-gutters">
            <div class="col-12">
              <h5 class="card-title mb-0">{{ columnsSrpOn[5].displayName }}</h5>
              <div class="card-text">
                <div *ngIf="cart.importStatus == 'PROCESSING'">
                  {{ 'csvImport.saveCart.importProcessing' | cxTranslate }}
                </div>
                <div *ngIf="cart.importResult && !cart.description; else normalDesc">
                  {{
                    'csvImport.saveCart.importDesc'
                      | cxTranslate
                        : { importRef: cart.importResult.importRef, importSuccess: cart.importResult.importSuccess }
                  }}
                  <ng-container *ngIf="cart.importResult.importFailed">
                    {{ 'csvImport.saveCart.importDescFailed' | cxTranslate }}
                    <button class="tertiary-btn btn" style="height: auto" (click)="openError(cart.code)">
                      {{
                        'csvImport.saveCart.importDescFailedNumber'
                          | cxTranslate : { importFailed: cart.importResult.importFailed }
                      }}
                    </button>
                  </ng-container>
                </div>
                <ng-template #normalDesc>
                  <div [innerHTML]="cart.description"></div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer p-0">
          <div class="row no-gutters">
            <div class="col-6 h-100 border-right">
              <button
                class="w-100 border-0 rounded-0 my-auto"
                mat-icon-button
                (click)="onDeleteSavedCartModal(cart.code, cart.name)"
              >
                <mat-icon class="material-icons light delete-cart">delete_outline</mat-icon>
              </button>
            </div>
            <div class="col-6 h-100">
              <button
                class="w-100 border-0 rounded-0 my-auto"
                mat-icon-button
                (click)="onRestoreSavedCartModal(cart.name, cart.code, cart.totalItems)"
              >
                <mat-icon matBadge="+" matBadgeSize="large" class="material-icons-sharp light restore-cart"
                  >shopping_cart</mat-icon
                >
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="pagination-container" *ngIf="savedCartsCount > 0">
    <app-pagination
      (viewPageEvent)="pageChange($event)"
      [pagination]="PaginationModel"
      [hideOnSinglePage]="true"
    ></app-pagination>
  </div>
</ng-template>
